module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"Text"},"de":{"text":"Text"}}')
  delete Component.options._Ctor
}
